import React, { Component } from 'react';
import '../../css/style.css';
import '../Home.css';
import { Card, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { translate } from "react-i18next";
import { EVENT_IMG_URL } from '../../backend/Backend';
import { Link } from 'react-router-dom';
import { getDateDisplayValue, isEditable } from '../../backend/UIUtils';




class EventResults extends Component {

  constructor(props) {
    super(props);

    this.state = {
      events: this.props.events
    };
  }

  toUrl(e){
    let sep = '-';
    let url = e.token + sep ;//+ e.eventId ;
    if(e.id ){
      url += e.id;
    }
    if(e.eventId ){
      url += e.eventId;
    }
   
    return url;
  }

  //<p className="card-text">{e.description}</p>
  render() {
    let sep = '-';
    
    const { t } = this.props;
    var options = { weekday: 'short', day: 'numeric', month: 'short', year: '2-digit', hour: 'numeric', minute: 'numeric' };
    return (
      <div >
        <Row className="justify-content-md-center" >
          {this.props.events.map((e, i) =>
            <Col lg={4} md={4} xs={12} className=" mb-2  " key={i}>
              <Card  style={{height:"100%"}}>
                <Card.Img variant="top" src={e.imageName ? EVENT_IMG_URL + e.imageName : "/img/produkt-premium-3.jpg"} height={"200px"}  />
                <Card.Body  >
                  <Card.Title  >
                    
                    <h4 className="card-title text-success "><i className={(e.eventType === 'ACTIVITY' ? " fas fa-globe-europe ":" fas fa-lock ")+ " s16  mr-1"} ></i>
                    {isEditable(e.creationUserId) ?
                       <Link to={`/eventEdit/${this.toUrl(e) + sep + e.creationUserId}`} className=" text-dark"  >{e.title}</Link>
                       :
                       <Link to={`/eventEdit/${this.toUrl(e) }`} className=" text-dark"  >{e.title}</Link>
                    }
                    </h4>
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    <Row>
                      <Col><i className="text-success fa fa-user s16  mr-1" ></i>{e.creationUserName}</Col>
                    </Row>
                    <Row>
                      <Col><i className="text-success fa fa-clock s16  mr-1" ></i>{getDateDisplayValue(e.startDate, options)}</Col>
                    </Row>

                  </Card.Subtitle>
                  <Card.Text>
                    {e.description}
                  </Card.Text>

                </Card.Body>
                {isEditable(e.creationUserId) ?
                  <Card.Footer>
                    <OverlayTrigger
                      key="top"
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-top`}>
                          {t("bearbeiten")}
                        </Tooltip>
                      }>
                      <Link to={`/eventChange/${this.toUrl(e)  + sep + e.creationUserId}`} className={' outline-primary float-right mr-1 '}>
                        <span className="text-primary fa fa-edit  mr-1"></span>{t("edit")}</Link>
                    </OverlayTrigger>
                  </Card.Footer>

                  :
                  ''
                }
              </Card>
            </Col>
          )
          }
        </Row>
      </div>
    );
  }
}

export default translate("translations")(EventResults);